import { FETCH_SURVEY_SUCCESS, RESET_QUESTIONS, RESET_APP } from '../../constants/action_types';

const questionsReducer = (state = [], action) => {
  switch (action.type) {
    case FETCH_SURVEY_SUCCESS:
      return action.questions;
    case RESET_QUESTIONS:
    case RESET_APP:
      return [];
    default:
      return state;
  }
};

export default questionsReducer;
